/* */ 
var defined = require('./_defined');
module.exports = function(it) {
  return Object(defined(it));
};
